export default function ({
  store,
  $config
}) {
  if (!store.state.host) {
    store.commit('setHost', $config.host)
  }
}
